import { checkAndCreateCard } from '@/features/withdraw-card/api/requests';
import type {
  CardCheckCreateResponse,
  CardCheckCreateBody,
} from '@/features/withdraw-card/model';
import { useMutation } from '@tanstack/react-query';

export function useCheckAndCreateCard() {
  const mutation = useMutation<
    CardCheckCreateResponse,
    Error,
    CardCheckCreateBody
  >({
    mutationFn: checkAndCreateCard,
    retry: 0,
  });

  return {
    checkAndCreateCardData: mutation.data,
    checkAndCreateCard: mutation.mutateAsync,
    checkAndCreateCardPending: mutation.isPending,
    checkAndCreateCardError: mutation.error,
  };
}
